import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getRiskAssessmentTemplates(context, { category, kind } = {}) {
    const params = {};
    if (category) params.category = category;
    if (kind) params.kind = kind;
    return axios
      .get("riskAssessmentTemplate", { params })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getRiskAssessmentTemplateCategories(context) {
    return axios
      .get("riskAssessmentTemplateCategory")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getRiskAssessmentTemplateCategoryCounts(context) {
    return axios
      .get("riskAssessmentTemplateCategory/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  createRiskAssessmentTemplateCategory(context, payload) {
    return axios
      .post("riskAssessmentTemplateCategory", payload)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.templates.folder.createdMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateRiskAssessmentTemplateCategory(context, payload) {
    return axios
      .put("riskAssessmentTemplateCategory/" + payload.id, payload)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.templates.folder.updatedMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteRiskAssessmentTemplateCategory(context, id) {
    return axios
      .delete("riskAssessmentTemplateCategory/" + id)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.templates.folder.deletedMessage"),
        );
        return r;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleRiskAssessmentTemplate(context, id) {
    return axios
      .get("riskAssessmentTemplate/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createRiskAssessmentTemplate(context, payload) {
    return axios
      .post("riskAssessmentTemplate", payload)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("riskAssessment.templates.createdMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateRiskAssessmentTemplate(context, payload) {
    return axios
      .put("riskAssessmentTemplate/" + payload._id, payload)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("riskAssessment.templates.updatedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteRiskAssessmentTemplate(context, id) {
    return axios
      .delete("riskAssessmentTemplate/" + id)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("riskAssessment.templates.deletedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
